// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    box-sizing: border-box; 
}
html{
    -webkit-text-size-adjust: none;
    font-size: calc(1.777777777777 * var(--my-vh) * var(--font-size-scale));
    font-size: 4.2666666666vw;
    display: flex;
    flex-direction: column;    
    width: 100%;
    height: 100%; 
    overflow-x: hidden; 
    line-height: 1.33;
    background: #000000;
} 
body{  
    font-family: 'Roboto';
    background: #000000;
    color: #fff;
    font-size: 1rem;
    margin: 0;
    padding: 0;
    flex-grow: 1;
    display: flex;
    flex-direction: column;  
} 
#root{ 
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    position: relative;
}
img{
    max-width: 100%;
    height: auto;
}
.preloadedImage{
    width: 1px;
    height: 1px;
    position: absolute;
    pointer-events: none;
    opacity: 0;
    -webkit-user-select: none;
            user-select: none;
    left: -9999px;
    top: -9999px;
}
a{
    color: inherit;
    -webkit-tap-highlight-color: transparent;
    text-decoration: none !important;
    transition: 0.3s opacity, 0.3s background, 0.3s color;
    -webkit-user-select: none;
            user-select: none;
}
button{
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
    transition: 0.3s opacity, 0.3s background, 0.3s color;
}
button:active,
a:active{
    opacity: 0.7;
}
button, input{ 
    -webkit-tap-highlight-color: transparent;
    font-size: 1em;
    font-family: 'Roboto';
}
u{ 
    text-decoration: underline;
}

strong{
    font-weight: 700;
} 
p{
    margin: 0;
    padding: 0;
}
b{
    font-weight: 500;
}
.slide-routes{
    width: 100%;
    height: 100%;
}
.item{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    max-width: 100vw;
}
.logo{ 
    display: none;
    width: 7.875em;
    margin: 3em auto 0;
    height: auto;
    transform: translateX(-0.1em);
    cursor: pointer;
} 
.frame{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    position: relative;
}
.frame__content{
    flex-grow: 1;
}
.btn{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 2.5em;
    font-weight: 500;
    border-radius: 0.75em;
    color: #fff;
    font-size: 1em;
    border: none;
    padding: 0;
    background: #FF5317; 
}
@media(min-width: 100vh){
    html{
        font-size: 2.04603vh;
    }
    body{
        overflow: hidden; 
    }
    .logo{
        display: block;
        flex-shrink: 0;
    }
    .btn{
        height: 3em;
    }
    .btn:hover{
        background: #454545;
    }
    .frame__mainImage--1 {
        width: 12.25em;
        transform: rotate(4.78deg) translateX(2.5em);
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;AACA;IACI,8BAA8B;IAC9B,uEAAuE;IACvE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,yBAAiB;YAAjB,iBAAiB;IACjB,aAAa;IACb,YAAY;AAChB;AACA;IACI,cAAc;IACd,wCAAwC;IACxC,gCAAgC;IAChC,qDAAqD;IACrD,yBAAiB;YAAjB,iBAAiB;AACrB;AACA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,qDAAqD;AACzD;AACA;;IAEI,YAAY;AAChB;AACA;IACI,wCAAwC;IACxC,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,UAAU;AACd;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;AACnB;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;AACA;IACI;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,cAAc;IAClB;IACA;QACI,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,4CAA4C;IAChD;AACJ","sourcesContent":["*{\n    box-sizing: border-box; \n}\nhtml{\n    -webkit-text-size-adjust: none;\n    font-size: calc(1.777777777777 * var(--my-vh) * var(--font-size-scale));\n    font-size: 4.2666666666vw;\n    display: flex;\n    flex-direction: column;    \n    width: 100%;\n    height: 100%; \n    overflow-x: hidden; \n    line-height: 1.33;\n    background: #000000;\n} \nbody{  \n    font-family: 'Roboto';\n    background: #000000;\n    color: #fff;\n    font-size: 1rem;\n    margin: 0;\n    padding: 0;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;  \n} \n#root{ \n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\nimg{\n    max-width: 100%;\n    height: auto;\n}\n.preloadedImage{\n    width: 1px;\n    height: 1px;\n    position: absolute;\n    pointer-events: none;\n    opacity: 0;\n    user-select: none;\n    left: -9999px;\n    top: -9999px;\n}\na{\n    color: inherit;\n    -webkit-tap-highlight-color: transparent;\n    text-decoration: none !important;\n    transition: 0.3s opacity, 0.3s background, 0.3s color;\n    user-select: none;\n}\nbutton{\n    user-select: none;\n    cursor: pointer;\n    transition: 0.3s opacity, 0.3s background, 0.3s color;\n}\nbutton:active,\na:active{\n    opacity: 0.7;\n}\nbutton, input{ \n    -webkit-tap-highlight-color: transparent;\n    font-size: 1em;\n    font-family: 'Roboto';\n}\nu{ \n    text-decoration: underline;\n}\n\nstrong{\n    font-weight: 700;\n} \np{\n    margin: 0;\n    padding: 0;\n}\nb{\n    font-weight: 500;\n}\n.slide-routes{\n    width: 100%;\n    height: 100%;\n}\n.item{\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    max-width: 100vw;\n}\n.logo{ \n    display: none;\n    width: 7.875em;\n    margin: 3em auto 0;\n    height: auto;\n    transform: translateX(-0.1em);\n    cursor: pointer;\n} \n.frame{\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n.frame__content{\n    flex-grow: 1;\n}\n.btn{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    height: 2.5em;\n    font-weight: 500;\n    border-radius: 0.75em;\n    color: #fff;\n    font-size: 1em;\n    border: none;\n    padding: 0;\n    background: #FF5317; \n}\n@media(min-width: 100vh){\n    html{\n        font-size: 2.04603vh;\n    }\n    body{\n        overflow: hidden; \n    }\n    .logo{\n        display: block;\n        flex-shrink: 0;\n    }\n    .btn{\n        height: 3em;\n    }\n    .btn:hover{\n        background: #454545;\n    }\n    .frame__mainImage--1 {\n        width: 12.25em;\n        transform: rotate(4.78deg) translateX(2.5em);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
